/* eslint-disable react/jsx-indent */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardHeader, NavItem, NavLink, Nav,
  TabContent, TabPane, Collapse,
} from 'reactstrap';
import {
  Table, Thead, Tbody, Tr, Th, Td,
} from 'react-super-responsive-table';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import classnames from 'classnames';
import { Can } from '../../../utilities/Can';

function ClientApiDocs(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const [verticalActiveTab, setverticalActiveTab] = useState('1');
  const [tokenSection, setTokenSection] = useState('request');
  const [invQtySection, setInvQtySection] = useState('request');
  const [orderDownloadSection, setOrderDownloadSection] = useState('200');
  const [markExportedSection, setMarkExportedSection] = useState('200');
  const [newShipmentSection, setNewShipmentSection] = useState('request');
  const [searchTermSection, setSearchTermSection] = useState('query');
  const [sourcingSuppliersSection, setSourcingSuppliersSection] = useState('200');
  const [sourcingOrderSection, setSourcingOrderSection] = useState('request');
  const [itemsListSection, setItemsListSection] = useState('query');
  const [itemsCreateSection, setItemsCreateSection] = useState('request');
  const [itemsTagsSection, setItemsTagsSection] = useState('200');

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader className="bg-transparent border-bottom">{props.t('Client API V1 Documentation')}</CardHeader>
              <CardBody className="client-api-docs">
                <style>
                  {`
                    .client-api-docs pre {
                      background: #17212b;
                      color: #f8fafc;
                      border: 1px solid rgba(148, 163, 184, 0.25);
                      border-radius: 0.75rem;
                      padding: 1rem;
                      overflow-x: auto;
                      white-space: pre-wrap;
                      word-break: break-word;
                    }

                    .client-api-docs .docs-params-table th,
                    .client-api-docs .docs-params-table td {
                      white-space: normal;
                      vertical-align: top;
                    }
                  `}
                </style>
                <Can i="see" this="client_api">
                  <Row>
                    <Col lg="2" xl="2">
                      <Nav pills className="flex-column">
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2': true,
                              active: verticalActiveTab === '1',
                            })}
                            onClick={() => {
                              toggleVertical('1');
                            }}
                          >
                            {t('Authentication')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2': true,
                              active: verticalActiveTab === '2',
                            })}
                            onClick={() => {
                              toggleVertical('2');
                            }}
                          >
                            {t('Stock Qty')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2': true,
                              active: verticalActiveTab === '3',
                            })}
                            onClick={() => {
                              toggleVertical('3');
                            }}
                          >
                            {t('Download Orders')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2': true,
                              active: verticalActiveTab === '4',
                            })}
                            onClick={() => {
                              toggleVertical('4');
                            }}
                          >
                            {t('Mark as Exported')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2': true,
                              active: verticalActiveTab === '5',
                            })}
                            onClick={() => {
                              toggleVertical('5');
                            }}
                          >
                          {t('Pack Shipment')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2': true,
                              active: verticalActiveTab === '11',
                            })}
                            onClick={() => {
                              toggleVertical('11');
                            }}
                          >
                            {t('Search Term Analytics')}
                          </NavLink>
                        </NavItem>
                        <NavItem className="mt-3">
                          <div className="text-uppercase fw-semibold text-muted small px-3">
                            {t('Sourcing')}
                          </div>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2 ps-4': true,
                              active: verticalActiveTab === '6',
                            })}
                            onClick={() => {
                              toggleVertical('6');
                            }}
                          >
                            {t('Get Suppliers')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2 ps-4': true,
                              active: verticalActiveTab === '7',
                            })}
                            onClick={() => {
                              toggleVertical('7');
                            }}
                          >
                            {t('Create Order')}
                          </NavLink>
                        </NavItem>
                        <NavItem className="mt-3">
                          <div className="text-uppercase fw-semibold text-muted small px-3">
                            {t('Items')}
                          </div>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2 ps-4': true,
                              active: verticalActiveTab === '8',
                            })}
                            onClick={() => {
                              toggleVertical('8');
                            }}
                          >
                            {t('Get Items')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2 ps-4': true,
                              active: verticalActiveTab === '9',
                            })}
                            onClick={() => {
                              toggleVertical('9');
                            }}
                          >
                            {t('Create Item')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2 ps-4': true,
                              active: verticalActiveTab === '10',
                            })}
                            onClick={() => {
                              toggleVertical('10');
                            }}
                          >
                            {t('Get Tags')}
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Col>

                    <Col lg="10" xl="10">
                      <TabContent
                        activeTab={verticalActiveTab}
                        className="text-muted mt-4 mt-md-0"
                      >
                        <TabPane tabId="1">
                          <section id="authentication">
                            <p>
                              The API requires authentication using a client ID and client secret
                              in order to obtain an access token. The access token is then used to
                              authenticate each request for up until the expiration time
                              (3 hrs at time of writing).
                              To which you then need to obtain a new access token.
                            </p>
                          </section>

                          <section id="get-token">
                            <h4>Get Token</h4>
                            <p>
                              To obtain an access token, you need to make a POST request to the
                              {' '}
                              <code>/api/v1/token</code>
                              {' '}
                              endpoint with the client ID and client secret in the request body.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">POST</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/token</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: tokenSection !== 'request' },
                                  )}
                                  type="button"
                                  onClick={() => setTokenSection('request')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Request Body
                                </button>
                              </h2>

                              <Collapse
                                isOpen={tokenSection === 'request'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="token_request">
                                    <pre>
                                      {JSON.stringify({
                                        client_id: 'your_client_id',
                                        client_secret: 'your_client_secret',
                                      }, null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: tokenSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setTokenSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={tokenSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="token_response_200">
                                    <pre>
                                      {JSON.stringify({
                                        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IlE...',
                                        expires: new Date(Date.now()),
                                      }, null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: tokenSection !== '400' },
                                  )}
                                  type="button"
                                  onClick={() => setTokenSection('400')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  400 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={tokenSection === '400'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="token_response_400">
                                    <pre>
                                      {JSON.stringify({
                                        error: 'Invalid client credentials',
                                      }, null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="2">
                          <section id="">
                            <p>
                              Here you are able to send a batch stock update
                              to the API. The API will then update the inventory
                              counts in the database. The API will return a 200 whether each entry
                              matched a item ID or not.
                            </p>
                          </section>

                          <section id="put-inventory-qty">
                            <h4>Update Stock Quantity</h4>
                            <p>
                              To update stock counts, you need to make a PUT request to the
                              {' '}
                              <code>/api/v1/stock/qty/:source</code>
                              {' '}
                              endpoint with an array of objects in the request body.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">PUT</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/stock/qty/:source</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: invQtySection !== 'request' },
                                  )}
                                  type="button"
                                  onClick={() => setInvQtySection('request')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Request Body
                                </button>
                              </h2>

                              <Collapse
                                isOpen={invQtySection === 'request'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="inventory_qty_request">
                                    <pre>
                                      {JSON.stringify([
                                        {
                                          stock_id: 'ABC123',
                                          total_qty: 5,
                                          cost: 10.99,
                                        },
                                        {
                                          stock_id: 'XYZ789',
                                          total_qty: 10,
                                          cost: 40.22,
                                        },
                                      ], null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: invQtySection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setInvQtySection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={invQtySection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="inventory_qty_response_200">
                                    <pre>
                                      {JSON.stringify([
                                        {
                                          item_id: 10934,
                                          total_qty: 5,
                                          success: true,
                                        },
                                        {
                                          item_id: 10485,
                                          total_qty: 10,
                                          success: true,
                                        },
                                      ], null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: invQtySection !== '400' },
                                  )}
                                  type="button"
                                  onClick={() => setInvQtySection('400')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  400 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={invQtySection === '400'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="token_response_400">
                                    <pre>
                                      {JSON.stringify({
                                        error: '"[1].total_qty" must be an integer',
                                      }, null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="3">
                          <section id="">
                            <p>
                              Download not-yet-exported orders from the API. The API will
                              return a 200 response with all of the orders in the response
                              body sorted from oldest to newest for digestion.
                            </p>

                            <p>
                              The API
                              {' '}
                              <u>
                                <strong>will not</strong>
                              </u>
                              {' '}
                              automatically update the exported
                              flag on the orders to 1 to indicate that they have
                              been exported. You need to confirm the order was recieved
                              well by using the API to mark the order as exported. It will
                              then be filtered out of subsequent api calls appropriately.
                            </p>
                          </section>

                          <section id="put-inventory-qty">
                            <h4>Download Orders</h4>
                            <p>
                              To download orders, you need to make a GET request to the
                              {' '}
                              <code>/api/v1/orders/download</code>
                              {' '}
                              endpoint
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">GET</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/orders/download</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: orderDownloadSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setOrderDownloadSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={orderDownloadSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="order_download_response_200">
                                  <pre>
                                    {JSON.stringify(JSON.parse('[{"id":4,"created_at":"2024-02-16T09:06:02.000Z","updated_at":"2024-02-16T18:18:18.000Z","reference":"50700022","ship_method":"UPS Ground","staff_note":"","customer_note":null,"po_number":null,"ship_to_address_id":2,"sold_to_address_id":2,"exported":0,"items":[{"id":2,"order_id":4,"inventory_id":76,"qty":1,"value":"42.39","currency_code":"USD","inventory_description":"Shark Replacement Motor/Chassis for","inventory_part_number":"XPODNV380","inventory_stock_id":"ABC123","qty_unshipped":0}],"shipTo":{"id":2,"firstname":"KJ","lastname":"Cowen","company":null,"telephone":"+18016371329","address_1":"798 E WHITEMAPLE WAY","address_2":null,"city":"Salt Lake City","region":"UT","postcode":"84106-1528","country":"US","email":"shuntsman18@yahoo.com"},"soldTo":{"id":2,"firstname":"KJ","lastname":"Cowen","company":null,"telephone":"+18016371329","address_1":"798 E WHITEMAPLE WAY","address_2":null,"city":"Salt Lake City","region":"UT","postcode":"84106-1528","country":"US","email":"shuntsman18@yahoo.com"}}]'), null, 2)}
                                  </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="4">
                          <section id="mark_exported">
                            <p>
                              Mark an order as received by the fulfillment system.
                              Necessary to filter out orders from subsequent download calls
                              and prevent double fulfillment.
                            </p>
                          </section>

                          <section id="put-inventory-qty">
                            <h4>Mark Order as &quot;Exported&quot;</h4>
                            <p>
                              To mark order as exported, you need to make a PUT request to the
                              {' '}
                              <code>
                                /api/v1/orders/markExported/&#123;order.id&#125;
                              </code>
                              {' '}
                              endpoint, replacing
                              &#123;order.id&#125; with the actual
                              {' '}
                              <em>id</em>
                              , not the reference ID.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">PUT</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/orders/markExported/&#123;order.id&#125;</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: markExportedSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setMarkExportedSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={markExportedSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="mark_exported_response_200">
                                    <pre>
                                      {JSON.stringify({}, null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="5">
                          <section id="new_shipment">
                            <p>
                              After you&apos;ve determined the items that will be
                              in a single parcel, you can create a new shipment,
                              indicate which of the items will be in the shipment, and optionally
                              include tracking info and carrier information (if shipped externally).
                            </p>
                          </section>

                          <section id="post-shipment-params">
                            <Table className="table table-sm table-bordered table-centered table-responsive docs-params-table">
                              <Thead>
                                <Tr>
                                  <Th>Param</Th>
                                  <Th>Type</Th>
                                  <Th>Description</Th>
                                  <Th>Required?</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td>lpn</Td>
                                  <Td>String</Td>
                                  <Td>Parcel reference ID (defaults to ID)</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>tracking_number</Td>
                                  <Td>String</Td>
                                  <Td>Tracking number</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>weight</Td>
                                  <Td>double</Td>
                                  <Td>Weight in LBS.</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>dimensions</Td>
                                  <Td>String</Td>
                                  <Td>Package dims in LxWxH format (inches.)</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>carrier</Td>
                                  <Td>String</Td>
                                  <Td>Must be one of UPS, USPS, Fedex</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>service</Td>
                                  <Td>String</Td>
                                  <Td>Shipment service</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>cost</Td>
                                  <Td>double</Td>
                                  <Td>Total cost of service</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>items[].order_item_id</Td>
                                  <Td>integer</Td>
                                  <Td>The &quot;order.item.id&quot; from order</Td>
                                  <Td className="text-danger">Yes</Td>
                                </Tr>
                                <Tr>
                                  <Td>items[].lot</Td>
                                  <Td>String</Td>
                                  <Td>Product lot number (45 chars max)</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>items[].serial</Td>
                                  <Td>String</Td>
                                  <Td>The product serial number (60 chars max)</Td>
                                  <Td>No</Td>
                                </Tr>
                                <Tr>
                                  <Td>items[].qty</Td>
                                  <Td>integer</Td>
                                  <Td>Must be at least 1</Td>
                                  <Td className="text-danger">Yes</Td>
                                </Tr>
                              </Tbody>
                            </Table>
                          </section>

                          <section id="post-shipment">
                            <h4>Packout a new shipment</h4>
                            <p>
                              To packout, you need to make a POST request to the
                              {' '}
                              <code>/api/v1/shipments/pack</code>
                              {' '}
                              endpoint with an object in the request body.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">POST</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/shipments/pack</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: newShipmentSection !== 'request' },
                                  )}
                                  type="button"
                                  onClick={() => setNewShipmentSection('request')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Request Body
                                </button>
                              </h2>

                              <Collapse
                                isOpen={newShipmentSection === 'request'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="new_shipment_request">
                                    <pre>
                                      {JSON.stringify(JSON.parse('{"tracking_number": "ABC123456789","weight": 5.75,"dimensions": "12x10x8","carrier": "UPS","service": "Ground","cost": 25.99,"items": [{"order_item_id": 123,"qty": 2},{"order_item_id": 456,"qty": 1}]}'), null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: newShipmentSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setNewShipmentSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={newShipmentSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="new_shipment_response_200">
                                    <pre>
                                      {JSON.stringify(JSON.parse('{"id":20,"order_id":4,"tracking_number":null,"weight":null,"dimensions":null,"carrier":null,"service":null,"cost":null,"created_at":"2024-02-21T08:39:32.000Z","updated_at":null,"shipped_at":null,"items":[{"id":18,"shipment_id":20,"order_item_id":2,"qty":1,"order_item":{"id":2,"order_id":4,"inventory_id":76,"qty":1,"value":"42.39","currency_code":"USD","inventory_description":"Shark Replacement Motor/Chassis for","inventory_part_number":"XPODNV380","inventory_stock_id":null,"qty_unshipped":0}}]}'), null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: newShipmentSection !== '400' },
                                  )}
                                  type="button"
                                  onClick={() => setNewShipmentSection('400')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  400 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={newShipmentSection === '400'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="new_shipment_response_400">
                                    <pre>
                                      {JSON.stringify(JSON.parse('{"error":"\\"items[0].qty\\" must be a positive number"}'), null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="6">
                          <section id="sourcing_suppliers">
                            <p>
                              Retrieve the slim supplier list for Sourcing along with the
                              available programs for each supplier. This is the preferred
                              endpoint for populating supplier and program pickers in client
                              integrations.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">GET</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/sourcing/suppliers</code>
                            </p>
                          </section>

                          <section id="sourcing_suppliers_notes" className="mb-3">
                            <Table className="table table-sm table-bordered table-centered table-responsive docs-params-table">
                              <Thead>
                                <Tr>
                                  <Th>Field</Th>
                                  <Th>Type</Th>
                                  <Th>Description</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td>id</Td>
                                  <Td>integer</Td>
                                  <Td>Supplier ID</Td>
                                </Tr>
                                <Tr>
                                  <Td>name</Td>
                                  <Td>string</Td>
                                  <Td>Supplier name</Td>
                                </Tr>
                                <Tr>
                                  <Td>programs[].id</Td>
                                  <Td>integer</Td>
                                  <Td>Program ID</Td>
                                </Tr>
                                <Tr>
                                  <Td>programs[].name</Td>
                                  <Td>string</Td>
                                  <Td>
                                    Program name to use in
                                    {' '}
                                    <code>supplier_program</code>
                                  </Td>
                                </Tr>
                              </Tbody>
                            </Table>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: sourcingSuppliersSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setSourcingSuppliersSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={sourcingSuppliersSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="sourcing_suppliers_response_200">
                                    <pre>
                                      {JSON.stringify([
                                        {
                                          id: 12,
                                          name: 'Acme Supply',
                                          programs: [
                                            {
                                              id: 101,
                                              name: 'Core Returns',
                                            },
                                            {
                                              id: 102,
                                              name: 'Overflow',
                                            },
                                          ],
                                        },
                                        {
                                          id: 13,
                                          name: 'Vendor B',
                                          programs: [],
                                        },
                                      ], null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="7">
                          <section id="sourcing_create_order">
                            <p>
                              Create a new sourcing order with the initial order info and
                              optionally associate existing trucks or create new trucks in the
                              same request.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">POST</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/sourcing/orders</code>
                            </p>
                            <Table className="table table-sm table-bordered table-centered table-responsive docs-params-table mb-3">
                              <Thead>
                                <Tr>
                                  <Th style={{ width: '180px' }}>{t('Rule')}</Th>
                                  <Th>{t('Explanation')}</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td>{t('Lot behavior')}</Td>
                                  <Td>
                                    If
                                    {' '}
                                    <code>lot</code>
                                    {' '}
                                    is omitted, null, or blank, the API generates
                                    {' '}
                                    <code>program.lot_prefix + reference</code>
                                    .
                                  </Td>
                                </Tr>
                              </Tbody>
                            </Table>
                          </section>

                          <section id="sourcing_create_order_params" className="mb-3">
                            <Table className="table table-sm table-bordered table-centered table-responsive docs-params-table">
                              <Thead>
                                <Tr>
                                  <Th>Field</Th>
                                  <Th>Type</Th>
                                  <Th>Description</Th>
                                  <Th>Required?</Th>
                                  <Th>Validation</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td>reference</Td>
                                  <Td>string</Td>
                                  <Td>Order reference / PO number</Td>
                                  <Td className="text-danger">Yes</Td>
                                  <Td>Trimmed, max 255 chars</Td>
                                </Tr>
                                <Tr>
                                  <Td>supplier_id</Td>
                                  <Td>integer</Td>
                                  <Td>Supplier ID</Td>
                                  <Td className="text-danger">Yes</Td>
                                  <Td>Positive integer, min 1</Td>
                                </Tr>
                                <Tr>
                                  <Td>supplier_program</Td>
                                  <Td>string</Td>
                                  <Td>Supplier program name. Must belong to the supplier.</Td>
                                  <Td className="text-danger">Yes</Td>
                                  <Td>Trimmed, max 90 chars</Td>
                                </Tr>
                                <Tr>
                                  <Td>cost</Td>
                                  <Td>number|null</Td>
                                  <Td>Total order cost</Td>
                                  <Td>No</Td>
                                  <Td>Up to 2 decimal places</Td>
                                </Tr>
                                <Tr>
                                  <Td>lot</Td>
                                  <Td>string|null</Td>
                                  <Td>
                                    Explicit lot value.
                                    {' '}
                                    If omitted or blank, it is auto-generated.
                                  </Td>
                                  <Td>No</Td>
                                  <Td>Trimmed, max 45 chars</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments</Td>
                                  <Td>array</Td>
                                  <Td>Existing trucks to attach or new trucks to create</Td>
                                  <Td>No</Td>
                                  <Td>Defaults to []</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].id</Td>
                                  <Td>integer</Td>
                                  <Td>Existing truck ID to attach</Td>
                                  <Td>No</Td>
                                  <Td>Positive integer, min 1</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].reference</Td>
                                  <Td>string</Td>
                                  <Td>Truck reference. Required when creating a new truck.</Td>
                                  <Td>No*</Td>
                                  <Td>Trimmed, max 255 chars</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].outbound</Td>
                                  <Td>integer</Td>
                                  <Td>Inbound/outbound flag</Td>
                                  <Td>No</Td>
                                  <Td>0 or 1, defaults to 0</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].cost</Td>
                                  <Td>number|null</Td>
                                  <Td>Truck cost</Td>
                                  <Td>No</Td>
                                  <Td>Up to 2 decimal places</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].labor_cost</Td>
                                  <Td>number|null</Td>
                                  <Td>Truck labor cost</Td>
                                  <Td>No</Td>
                                  <Td>Up to 2 decimal places</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].shipping_cost</Td>
                                  <Td>number|null</Td>
                                  <Td>Truck shipping cost</Td>
                                  <Td>No</Td>
                                  <Td>Up to 2 decimal places</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].expected_at</Td>
                                  <Td>date|null</Td>
                                  <Td>Expected arrival or pickup date</Td>
                                  <Td>No</Td>
                                  <Td>Any valid date</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].origin</Td>
                                  <Td>string|null</Td>
                                  <Td>Origin or destination text</Td>
                                  <Td>No</Td>
                                  <Td>Blank allowed</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].pallet_count</Td>
                                  <Td>integer|null</Td>
                                  <Td>Number of pallets</Td>
                                  <Td>No</Td>
                                  <Td>Integer, min 0</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].unit_count</Td>
                                  <Td>integer|null</Td>
                                  <Td>Number of units</Td>
                                  <Td>No</Td>
                                  <Td>Integer, min 0</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].comments</Td>
                                  <Td>string|null</Td>
                                  <Td>Freeform notes</Td>
                                  <Td>No</Td>
                                  <Td>Blank allowed</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].received_at</Td>
                                  <Td>date|null</Td>
                                  <Td>Truck received timestamp</Td>
                                  <Td>No</Td>
                                  <Td>Any valid date</Td>
                                </Tr>
                                <Tr>
                                  <Td>shipments[].staged_lanes</Td>
                                  <Td>string|null</Td>
                                  <Td>Staged lanes text</Td>
                                  <Td>No</Td>
                                  <Td>Blank allowed</Td>
                                </Tr>
                              </Tbody>
                            </Table>
                            <p className="mb-0">
                              * Each shipment must include either
                              {' '}
                              <code>id</code>
                              {' '}
                              or
                              {' '}
                              <code>reference</code>
                              .
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: sourcingOrderSection !== 'request' },
                                  )}
                                  type="button"
                                  onClick={() => setSourcingOrderSection('request')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Request Body
                                </button>
                              </h2>

                              <Collapse
                                isOpen={sourcingOrderSection === 'request'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="sourcing_create_order_request">
                                    <pre>
                                      {JSON.stringify({
                                        reference: 'PO-12345',
                                        supplier_id: 12,
                                        supplier_program: 'Core Returns',
                                        cost: 2500.00,
                                        lot: null,
                                        shipments: [
                                          {
                                            reference: 'BOL-9988',
                                            outbound: 0,
                                            cost: 450.00,
                                            labor_cost: null,
                                            shipping_cost: null,
                                            expected_at: '2026-05-30',
                                            origin: 'Dallas, TX',
                                            pallet_count: 12,
                                            unit_count: null,
                                            comments: null,
                                            received_at: null,
                                            staged_lanes: null,
                                          },
                                          {
                                            id: 77,
                                          },
                                        ],
                                      }, null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: sourcingOrderSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setSourcingOrderSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={sourcingOrderSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="sourcing_create_order_response_200">
                                    <pre>
                                      {JSON.stringify({
                                        id: 321,
                                        reference: 'PO-12345',
                                        lot: 'CRPO-12345',
                                        supplier_id: 12,
                                        supplier_program: 'Core Returns',
                                        cost: 2500,
                                        created_at: '2026-05-22T15:12:00.000Z',
                                        shipments: [
                                          {
                                            id: 88,
                                            reference: 'BOL-9988',
                                          },
                                          {
                                            id: 77,
                                            reference: 'EXISTING-TRUCK',
                                          },
                                        ],
                                      }, null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: sourcingOrderSection !== '400' },
                                  )}
                                  type="button"
                                  onClick={() => setSourcingOrderSection('400')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  400 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={sourcingOrderSection === '400'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <section id="sourcing_create_order_response_400">
                                    <pre>
                                      {JSON.stringify({
                                        error: 'Supplier program not found for supplier',
                                      }, null, 2)}
                                    </pre>
                                  </section>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="8">
                          <section id="items_get_items">
                            <p>
                              Retrieve paginated Items records for client integrations.
                              This endpoint supports search, simple filtering, and
                              pagination.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">GET</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/items</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: itemsListSection !== 'query' },
                                  )}
                                  type="button"
                                  onClick={() => setItemsListSection('query')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Query Parameters
                                </button>
                              </h2>

                              <Collapse
                                isOpen={itemsListSection === 'query'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <Table className="table table-sm table-bordered table-centered table-responsive docs-params-table">
                                    <Thead>
                                      <Tr>
                                        <Th>Param</Th>
                                        <Th>Type</Th>
                                        <Th>Description</Th>
                                        <Th>Required?</Th>
                                        <Th>Validation</Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      <Tr>
                                        <Td>query</Td>
                                        <Td>string|null</Td>
                                        <Td>Search text</Td>
                                        <Td>No</Td>
                                        <Td>Blank allowed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>filter</Td>
                                        <Td>string|null</Td>
                                        <Td>Raw filter string for field=value pairs</Td>
                                        <Td>No</Td>
                                        <Td>Blank allowed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>page</Td>
                                        <Td>integer</Td>
                                        <Td>Page number</Td>
                                        <Td>No</Td>
                                        <Td>Min 1, default 1</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>per</Td>
                                        <Td>integer</Td>
                                        <Td>Results per page</Td>
                                        <Td>No</Td>
                                        <Td>Min 1, max 250, default 25</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>sort</Td>
                                        <Td>string</Td>
                                        <Td>Sort field</Td>
                                        <Td>No</Td>
                                        <Td>
                                          <code>id</code>
                                          {' '}
                                          or
                                          {' '}
                                          <code>created_at</code>
                                        </Td>
                                      </Tr>
                                      <Tr>
                                        <Td>dir</Td>
                                        <Td>string</Td>
                                        <Td>Sort direction</Td>
                                        <Td>No</Td>
                                        <Td>
                                          <code>asc</code>
                                          {' '}
                                          or
                                          {' '}
                                          <code>desc</code>
                                          , default
                                          {' '}
                                          <code>desc</code>
                                        </Td>
                                      </Tr>
                                    </Tbody>
                                  </Table>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: itemsListSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setItemsListSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={itemsListSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <pre>
                                    {JSON.stringify({
                                      results: [
                                        {
                                          id: 101,
                                          manufacturer: 'Samsung',
                                          part_number: 'BN44-12345A',
                                          condition: 'Like New',
                                          customs_description: 'Power supply board',
                                          value_usd: '18.50',
                                          created_at: '2026-05-22T15:12:00.000Z',
                                          tags: [
                                            { id: 5, label: 'Power' },
                                          ],
                                          devices: [
                                            {
                                              id: 22,
                                              brand: 'Samsung',
                                              model: 'UN55NU6900',
                                              version: '',
                                            },
                                          ],
                                          images: [
                                            {
                                              id: 9,
                                              label: 'Front',
                                              url: 'https://example.com/item-front.jpg',
                                            },
                                          ],
                                        },
                                      ],
                                      total: 1,
                                    }, null, 2)}
                                  </pre>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="9">
                          <section id="items_create_item">
                            <p>
                              Create a new item record through the client API, including
                              device compatibility, tags, and optional hosted or base64
                              image uploads.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">POST</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/items/create</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: itemsCreateSection !== 'request' },
                                  )}
                                  type="button"
                                  onClick={() => setItemsCreateSection('request')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Request Body
                                </button>
                              </h2>

                              <Collapse
                                isOpen={itemsCreateSection === 'request'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <Table className="table table-sm table-bordered table-centered table-responsive docs-params-table mb-3">
                                    <Thead>
                                      <Tr>
                                        <Th>Field</Th>
                                        <Th>Type</Th>
                                        <Th>Description</Th>
                                        <Th>Required?</Th>
                                        <Th>Validation</Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      <Tr>
                                        <Td>part_number</Td>
                                        <Td>string</Td>
                                        <Td>Manufacturer part number</Td>
                                        <Td className="text-danger">Yes</Td>
                                        <Td>Trimmed, max 255 chars</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>manufacturer</Td>
                                        <Td>string</Td>
                                        <Td>Item manufacturer</Td>
                                        <Td className="text-danger">Yes</Td>
                                        <Td>Trimmed, max 60 chars</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>device_manufacturer</Td>
                                        <Td>string|null</Td>
                                        <Td>Device brand override</Td>
                                        <Td>No</Td>
                                        <Td>Trimmed, max 60 chars</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>customs_value</Td>
                                        <Td>number</Td>
                                        <Td>Declared customs value</Td>
                                        <Td className="text-danger">Yes</Td>
                                        <Td>Min 0</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>customs_description</Td>
                                        <Td>string</Td>
                                        <Td>Declared customs description</Td>
                                        <Td className="text-danger">Yes</Td>
                                        <Td>Trimmed, max 35 chars</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>condition</Td>
                                        <Td>string|null</Td>
                                        <Td>Item condition</Td>
                                        <Td>No</Td>
                                        <Td>Trimmed, max 45 chars</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>type</Td>
                                        <Td>string|null</Td>
                                        <Td>Item type</Td>
                                        <Td>No</Td>
                                        <Td>Trimmed, max 45 chars</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>weight</Td>
                                        <Td>number|null</Td>
                                        <Td>Weight value</Td>
                                        <Td>No</Td>
                                        <Td>Nullable</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>ship_dims</Td>
                                        <Td>string|null</Td>
                                        <Td>Shipping dimensions</Td>
                                        <Td>No</Td>
                                        <Td>Trimmed, max 45 chars</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>variant_label</Td>
                                        <Td>string|null</Td>
                                        <Td>Variant label</Td>
                                        <Td>No</Td>
                                        <Td>Trimmed, max 90 chars</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>profile_id</Td>
                                        <Td>integer|null</Td>
                                        <Td>Profile ID</Td>
                                        <Td>No</Td>
                                        <Td>Positive integer</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>alert</Td>
                                        <Td>string|null</Td>
                                        <Td>Freeform alert text</Td>
                                        <Td>No</Td>
                                        <Td>Blank allowed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>scrap</Td>
                                        <Td>integer|null</Td>
                                        <Td>Scrap quantity or threshold</Td>
                                        <Td>No</Td>
                                        <Td>Integer</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>tags</Td>
                                        <Td>integer[]</Td>
                                        <Td>Tag IDs to relate to the item</Td>
                                        <Td>No</Td>
                                        <Td>Positive integers, default []</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>devices</Td>
                                        <Td>array</Td>
                                        <Td>Compatible device definitions</Td>
                                        <Td className="text-danger">Yes</Td>
                                        <Td>At least 1 device</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>devices[].brand</Td>
                                        <Td>string</Td>
                                        <Td>Device brand</Td>
                                        <Td className="text-danger">Yes</Td>
                                        <Td>Trimmed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>devices[].model</Td>
                                        <Td>string</Td>
                                        <Td>Device model</Td>
                                        <Td className="text-danger">Yes</Td>
                                        <Td>Trimmed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>devices[].version</Td>
                                        <Td>string|null</Td>
                                        <Td>Device version</Td>
                                        <Td>No</Td>
                                        <Td>Blank allowed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>devices[].size</Td>
                                        <Td>number|null</Td>
                                        <Td>Device size</Td>
                                        <Td>No</Td>
                                        <Td>Nullable</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>images</Td>
                                        <Td>array</Td>
                                        <Td>Optional item images</Td>
                                        <Td>No</Td>
                                        <Td>Default []</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>images[].label</Td>
                                        <Td>string|null</Td>
                                        <Td>Image label</Td>
                                        <Td>No</Td>
                                        <Td>Blank allowed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>images[].is_default</Td>
                                        <Td>boolean</Td>
                                        <Td>Whether this is the default image</Td>
                                        <Td>No</Td>
                                        <Td>Defaults to false</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>images[].url</Td>
                                        <Td>string|null</Td>
                                        <Td>Remote image URL</Td>
                                        <Td>No*</Td>
                                        <Td>Must be a valid URI if present</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>images[].data</Td>
                                        <Td>string|null</Td>
                                        <Td>Base64 image data</Td>
                                        <Td>No*</Td>
                                        <Td>Blank allowed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>images[].filename</Td>
                                        <Td>string|null</Td>
                                        <Td>Optional upload filename</Td>
                                        <Td>No</Td>
                                        <Td>Blank allowed</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>images[].mime_type</Td>
                                        <Td>string|null</Td>
                                        <Td>Optional MIME type</Td>
                                        <Td>No</Td>
                                        <Td>Blank allowed</Td>
                                      </Tr>
                                    </Tbody>
                                  </Table>
                                  <p className="mb-3">
                                    * Each image must provide either
                                    {' '}
                                    <code>url</code>
                                    {' '}
                                    or
                                    {' '}
                                    <code>data</code>
                                    .
                                  </p>
                                  <pre>
                                    {JSON.stringify({
                                      part_number: 'BN44-12345A',
                                      manufacturer: 'Samsung',
                                      customs_value: 18.50,
                                      customs_description: 'Power supply board',
                                      condition: 'Like New',
                                      type: 'Board',
                                      weight: 1.25,
                                      ship_dims: '12x10x2',
                                      variant_label: 'Rev A',
                                      profile_id: 4,
                                      alert: '',
                                      scrap: 0,
                                      tags: [5, 7],
                                      devices: [
                                        {
                                          brand: 'Samsung',
                                          model: 'UN55NU6900',
                                          version: '',
                                          size: 55,
                                        },
                                      ],
                                      images: [
                                        {
                                          label: 'Front',
                                          is_default: true,
                                          url: 'https://example.com/item-front.jpg',
                                        },
                                      ],
                                    }, null, 2)}
                                  </pre>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: itemsCreateSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setItemsCreateSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={itemsCreateSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <pre>
                                    {JSON.stringify({
                                      id: 101,
                                      manufacturer: 'Samsung',
                                      part_number: 'BN44-12345A',
                                      condition: 'Like New',
                                      customs_description: 'Power supply board',
                                      value_usd: '18.50',
                                      created_by: 'Client API',
                                      tags: [
                                        { id: 5, label: 'Power' },
                                        { id: 7, label: 'Main Board' },
                                      ],
                                      devices: [
                                        {
                                          id: 22,
                                          brand: 'Samsung',
                                          model: 'UN55NU6900',
                                          version: '',
                                        },
                                      ],
                                      images: [
                                        {
                                          id: 9,
                                          label: 'Front',
                                          is_default: 1,
                                          url: 'https://example.com/item-front.jpg',
                                        },
                                      ],
                                    }, null, 2)}
                                  </pre>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: itemsCreateSection !== '400' },
                                  )}
                                  type="button"
                                  onClick={() => setItemsCreateSection('400')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  400 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={itemsCreateSection === '400'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <pre>
                                    {JSON.stringify({
                                      error: '"devices" must contain at least 1 items',
                                    }, null, 2)}
                                  </pre>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="10">
                          <section id="items_get_tags">
                            <p>
                              Retrieve the available item tags for client-side forms.
                              This returns a slim tag list with just the fields needed
                              to build selectors.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">GET</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/items/tags</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: itemsTagsSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setItemsTagsSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={itemsTagsSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <pre>
                                    {JSON.stringify([
                                      {
                                        id: 5,
                                        label: 'Power',
                                      },
                                      {
                                        id: 7,
                                        label: 'Main Board',
                                      },
                                    ], null, 2)}
                                  </pre>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="11">
                          <section id="search_term_analytics">
                            <p>
                              Retrieve aggregated search activity for a search term across
                              multiple integrations over the last 90 days.
                            </p>
                            <p>
                              The response combines Partner API search logs and Best Buy /
                              Fidelitone needs logs into one summary plus a source breakdown.
                            </p>
                            <p className="fs-4">
                              <span className="text-dark">GET</span>
                              {' '}
                              <code style={{ fontSize: '20px' }}>/api/v1/search-term</code>
                            </p>
                          </section>

                          <div className="accordion accordion-flush">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: searchTermSection !== 'query' },
                                  )}
                                  type="button"
                                  onClick={() => setSearchTermSection('query')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Query Parameters
                                </button>
                              </h2>

                              <Collapse
                                isOpen={searchTermSection === 'query'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <Table className="table table-sm table-bordered table-centered table-responsive docs-params-table">
                                    <Thead>
                                      <Tr>
                                        <Th>Param</Th>
                                        <Th>Type</Th>
                                        <Th>Description</Th>
                                        <Th>Required?</Th>
                                        <Th>Validation</Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      <Tr>
                                        <Td>term</Td>
                                        <Td>string</Td>
                                        <Td>Search term to analyze</Td>
                                        <Td className="text-danger">Yes</Td>
                                        <Td>Trimmed, max 90 chars</Td>
                                      </Tr>
                                    </Tbody>
                                  </Table>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: searchTermSection !== '200' },
                                  )}
                                  type="button"
                                  onClick={() => setSearchTermSection('200')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  200 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={searchTermSection === '200'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <pre>
                                    {JSON.stringify({
                                      term: 'BN44-12345A',
                                      window_days: 90,
                                      window_start_at: '2026-02-21T15:45:00.000Z',
                                      totals: {
                                        total_search_count: 9,
                                        last_searched_at: '2026-05-22T15:45:00.000Z',
                                        total_current_results_count: 6,
                                        total_requested_qty: 14,
                                        best_buy_success_count: 3,
                                        best_buy_failure_count: 2,
                                      },
                                      breakdown: [
                                        {
                                          source: 'partner_api',
                                          searched_by: 'partner-site-a',
                                          search_count: 4,
                                          current_results_count: 2,
                                          last_searched_at: '2026-05-22T14:10:00.000Z',
                                        },
                                        {
                                          source: 'partner_api',
                                          searched_by: 'partner-site-b',
                                          search_count: 2,
                                          current_results_count: 4,
                                          last_searched_at: '2026-05-22T15:45:00.000Z',
                                        },
                                        {
                                          source: 'fidelitone',
                                          searched_by: 'best_buy',
                                          search_count: 3,
                                          success_count: 2,
                                          failure_count: 1,
                                          requested_qty_total: 14,
                                          last_searched_at: '2026-05-22T13:05:00.000Z',
                                        },
                                      ],
                                    }, null, 2)}
                                  </pre>
                                </div>
                              </Collapse>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={classnames(
                                    'accordion-button',
                                    'fw-medium',
                                    { collapsed: searchTermSection !== '400' },
                                  )}
                                  type="button"
                                  onClick={() => setSearchTermSection('400')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  400 Response Example
                                </button>
                              </h2>

                              <Collapse
                                isOpen={searchTermSection === '400'}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <pre>
                                    {JSON.stringify({
                                      error: '"term" is required',
                                    }, null, 2)}
                                  </pre>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </TabPane>
                      </TabContent>
                    </Col>
                  </Row>
                </Can>

                <Can not i="see" this="client_api"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

ClientApiDocs.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ClientApiDocs));
